import { Injectable } from '@angular/core';
import { FormControl, FormGroup, Validators } from '@angular/forms';
import { of } from 'rxjs';
import { QuestionBase } from '../patrol-template-management/controls/question-base';
import { SelectQuestion } from '../patrol-template-management/controls/question-select';
import { InputQuestion } from '../patrol-template-management/controls/question-input';
import { DatePickerQuestion } from '../patrol-template-management/controls/question-datepicker';
import { InputNumberQuestion } from '../patrol-template-management/controls/question-inputnumber';
import { TextAreaQuestion } from '../patrol-template-management/controls/question-textarea';
import { CheckBoxQuestion } from '../patrol-template-management/controls/question-checkbox';
import { UpLoadQuestion } from '../patrol-template-management/controls/question-upload';


@Injectable({
  providedIn: 'root'
})
export class QuestionService {

  // TODO: get from a remote source of question metadata
  getQuestions() {

    const questions: QuestionBase<string>[] = [

      new SelectQuestion({
        key: 'brave',
        label: 'Bravery Rating',
        options: [
          {key: 'solid',  value: 'Solid'},
          {key: 'great',  value: 'Great'},
          {key: 'good',   value: 'Good'},
          {key: 'unproven', value: 'Unproven'}
        ],
        order: 1
      }),

      new InputQuestion({
        key: 'firstName',
        label: 'First name',
        value: '',
        required: 1,
        order: 2
      }),
      new InputQuestion({
        key: 'email',
        label: 'email',
        value: '',
        required: 1,
        email: 1,
        order: 3
      }),

      new DatePickerQuestion({
        key: 'datepicker',
        label: 'datepicker',
        type: 'datepicker',
        order: 4
      }),
      new InputNumberQuestion({
        key: 'number',
        label: 'number',
        order: 5
      }),
      new TextAreaQuestion({
        key: 'textarea',
        label: 'textarea',
        type: 'textarea',
        order: 6,
      }),
      new CheckBoxQuestion({
        key: 'checkbox',
        label: 'checkbox',
        type: 'checkbox',
        order: 7,
      })
    ];

    return of(questions.sort((a, b) => a.order - b.order));
  }
  toFormGroup(questions: QuestionBase<string>[] ) {
    const group: any = {};
    questions.forEach(question => {
      const  validators = [];
      if (question.required){
        validators.push(Validators.required);
      }
      if (question.email){
        validators.push(Validators.email);
      }
      if (question.ptctNo === 'checkbox'){
        // group[question.key] = validators.length > 0 ? new FormControl((question.value === '1') ? true : false, validators)
        //                                       : new FormControl((question.value === '1') ? true : false);
        group[question.key] = validators.length > 0 ? new FormControl(this.isEmpty(question.value) ? false : question.value, validators)
                                              : new FormControl(this.isEmpty(question.value) ? false : question.value);
      }else{
        group[question.key] = validators.length > 0 ? new FormControl(question.value || '', validators)
        : new FormControl(question.value || '');
      }
    });
    return new FormGroup(group);
  }
  // code 0 表示移动端 1表示web端
  getControl(type: any, option: any, code: number){
    let control = null;
    switch (type){
      case 'input':
        control = new InputQuestion({
          key: option.key,
          label: option.label,
          value: !this.isEmpty(option.value) ? option.value : '',
          required: !this.isEmpty(option.required) ? (option.required ? 1 : 0) : 0,
          order: option.order,
          row: option.row,
          column: option.column,
          placeholder: !this.isEmpty(option.placeholder) ? option.placeholder : '',
          unit: option.unit,
          format: option.format,
        });
        break;
      case 'inputnumber':
        control = new InputNumberQuestion({
          key: option.key,
          label: option.label,
          value: !this.isEmpty(option.value) ? option.value : '',
          required: !this.isEmpty(option.required) ? (option.required ? 1 : 0) : 0,
          order: option.order,
          row: option.row,
          column: option.column,
          placeholder: !this.isEmpty(option.placeholder) ? option.placeholder : '',
          unit: option.unit,
          format: option.format,
        });
        break;
      case 'textarea':
        control = new TextAreaQuestion({
          key: option.key,
          label: option.label,
          value: !this.isEmpty(option.value) ? option.value : '',
          required: !this.isEmpty(option.required) ? (option.required ? 1 : 0) : 0,
          order: option.order,
          row: option.row,
          column: option.column,
          placeholder: !this.isEmpty(option.placeholder) ? option.placeholder : '',
          unit: option.unit,
          format: option.format,
        });
        break;
      case 'checkbox':
        control = new CheckBoxQuestion({
          key: option.key,
          label: option.label,
          value: !this.isEmpty(option.value) ? option.value : false,
          required: !this.isEmpty(option.required) ? (option.required ? 1 : 0) : 0,
          order: option.order,
          row: option.row,
          column: option.column,
          placeholder: !this.isEmpty(option.placeholder) ? option.placeholder : '',
          unit: option.unit,
          format: option.format,
        });
        break;
      case 'datepicker':
        control = new DatePickerQuestion({
          key: option.key,
          label: option.label,
          value: !this.isEmpty(option.value) ? option.value : '',
          required: !this.isEmpty(option.required) ? (option.required ? 1 : 0) : 0,
          order: option.order,
          placeholder: !this.isEmpty(option.placeholder) ? option.placeholder : '',
          unit: option.unit,
          format: option.format,
        });
        break;
      case 'select':
        const ls = option.options.split(',');
        // const  optionList: {key: string, value: string}[] = [];
        const  optionList: any[] = [];
        ls.forEach(( item: any, index: any) => {
          if (code === 0){
            optionList.push({
              value: option.key + '' + index,
              label: item
            });
          }else{
            optionList.push({
              key: option.key + '' + index,
              value: item
            });
          }
        });
        control = new SelectQuestion({
          key: option.key,
          label: option.label,
          value: !this.isEmpty(option.value) ? option.value : '',
          required: !this.isEmpty(option.required) ? (option.required ? 1 : 0) : 0,
          order: option.order,
          // tslint:disable-next-line:no-eval
          options: optionList,
          placeholder: !this.isEmpty(option.placeholder) ? option.placeholder : '',
          unit: option.unit,
          format: option.format,
        });
        break;
      case 'upload':
        control = new UpLoadQuestion({
          key: option.key,
          label: option.label,
          value: !this.isEmpty(option.value) ? option.value : '',
          required: !this.isEmpty(option.required) ? (option.required ? 1 : 0) : 0,
          order: option.order,
          placeholder: !this.isEmpty(option.placeholder) ? option.placeholder : '',
          unit: option.unit,
          format: option.format,
          attachments: []
        });
        break;
    }
    return control;
  }
  public isEmpty(obj: any) {
    if (typeof obj === 'undefined' || obj === null || obj === '') {
      return true;
    } else {
      return false;
    }
  }
}
